module.exports = __webpack_public_path__ + "static/media/Sunrise Elmvale - Order appointing receiver.35860668.pdf";